import React from 'react';
import { Typography } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
    root: {},
    givingInstructionsTitle: {
        fontWeight: typography.fontWeightBold,
    },
    givingMethodTitle: {
        marginTop: spacing(2),
        fontWeight: typography.fontWeightBold,
    },
    givingMethodBullettedList: {
        margin: [[0, 0, 0, spacing(2)]],
    },
    contact: {
        color: palette.grey[400],
        marginTop: spacing(2),
        textAlign: 'center',
    },
}));

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function VancouverTraditionalChineseGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_vancouver`,
        classes.root,
    );

    const givingMethodTitleClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_title`,
        classes.givingMethodTitle,
    );

    const givingMethodBullettedListClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_method_bulleted_list`,
        classes.givingMethodBullettedList,
    );

    return (
        <div className={rootClassNames}>
            <Typography
                // eslint-disable-next-line max-len
                className={ClassNames(classes.givingInstructionsTitle, `${BEM_BLOCK_NAME}--giving_instructions_title`)}
                component="div"
                variant="body1"
            >
                奉獻方式
            </Typography>

            <div className={givingMethodTitleClassNames}>E-Transfer 電子轉帳</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>
                    請透過你金融機構的加拿大銀行賬戶轉帳至
                    <a href="mailto:VANCOUVER@SADDLEBACKCA.COM">VANCOUVER@SADDLEBACKCA.COM</a>
                </li>
                <li>{`言/參考欄寫上「${campaignName}」、你的英文全名、電話號碼及電郵地址`}</li>
            </ul>

            <div className={givingMethodTitleClassNames}>支票/現金</div>
            <ul className={givingMethodBullettedListClassNames}>
                <li>請在支票抬頭寫 SADDLEBACK CHURCH HONG KONG (VANCOUVER)</li>
                <li>{`請將現金或支票捐款放入奉獻封內，註明為「${campaignName}」。填上你的英文全名、電話號碼及電郵地址`}</li>
            </ul>

            <div className={ClassNames(`${BEM_BLOCK_NAME}--giving_instructions_vancouver_contact`, classes.contact)}>
                如有任何有關「築夢計劃」奉獻查詢，可電郵至
                {'\u00a0'}
                <a href="mailto:accounting@saddlebackca.com">accounting@saddlebackca.com</a>
            </div>
        </div>
    );
}

export default VancouverTraditionalChineseGivingInstructions;
